import script from "./Skelaton.vue?vue&type=script&setup=true&lang=js"
export * from "./Skelaton.vue?vue&type=script&setup=true&lang=js"

import "./Skelaton.vue?vue&type=style&index=0&id=04a85f88&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a85f88"]])

export default __exports__